// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2a-PS","top":"styles_top__1KiXP","left":"styles_left__2ycxP","description":"styles_description__2xzzr"};